import React from 'react';

type HeadingSize = 'sm' | 'md' | 'lg' | 'xl';

interface SectionHeadingProps {
  title: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3' | 'h4';
  size?: HeadingSize;
  muted?: boolean;
  className?: string;
  children?: React.ReactNode;
  action?: React.ReactNode;
}

const SIZE_CONFIG: Record<HeadingSize, { bar: string; text: string; gap: string }> = {
  sm: { bar: 'w-1 h-6', text: 'text-2xl', gap: 'gap-2' },
  md: { bar: 'w-1.5 h-7', text: 'text-2xl', gap: 'gap-3' },
  lg: { bar: 'w-1.5 h-8', text: 'text-3xl', gap: 'gap-3' },
  xl: { bar: 'w-1.5 h-10', text: 'text-3xl md:text-5xl', gap: 'gap-3' },
};

const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  as: Tag = 'h2',
  size = 'lg',
  muted = false,
  className = '',
  children,
  action,
}) => {
  const config = SIZE_CONFIG[size];
  const textColor = muted ? 'text-slate-400' : 'text-white';

  const heading = (
    <div className={`flex items-center ${config.gap}`}>
      <div className={`${config.bar} bg-yellow-400 rounded-sm shrink-0`} />
      {children ? (
        <div>
          <Tag className={`font-bebas ${config.text} ${textColor} italic tracking-tight`}>
            {title}
          </Tag>
          {children}
        </div>
      ) : (
        <Tag className={`font-bebas ${config.text} ${textColor} italic tracking-tight`}>
          {title}
        </Tag>
      )}
    </div>
  );

  if (action) {
    return (
      <div className={`flex items-center justify-between ${className}`}>
        {heading}
        {action}
      </div>
    );
  }

  return <div className={className}>{heading}</div>;
};

export default SectionHeading;
